const defaultQuestions = [
  "Guide me with installation procedure for cimatron software. Give concise answer.",
  "How can I counter the issue, where I am unable to install the cimatron software. give me few troubleshoot points.",
  "List of application that could cause problem during the installation of cimatron software?",
  "Cimatron software installation is crashing. What could be the cause and what should I do?",
  "How to change the installation directory for the cimatron software?",
  "Is it possible to install multiple versions of cimatron software? will it cause any issues? Give concise answer.",
  "What is the meaning of additional installation for a new major version cimatron software?",
  "How to download new catalogs through catalog update tool?",
  "How to install a license server used to host the floating license as a server system?",
  "What options are available to uninstall cimatron software? Give concise answer.",
  "What is data interface in cimatron software? give concise answer.",
  "List file formats which Data interface in cimatron software supports? give exhaustive list of file format.",
  "Reason for being unable to import step file into cimatron software through DI?",
  "Why some parts were missing, while importing IGES file format into cimatron software?",
  "Give me different ways in which external file format can be opened directly in cimatron software.",
  "How to convert mold assembly file created in cimatron software to NX format file.",
  "How drag & drop is different from Import? give concise answer.",
  "What is vda file format?",
  "How to use publish to pdf command to export 3d model in pdf format?"
];

export const pickRandomQuestions = (count = 4) => {
  return [...defaultQuestions].sort(() => Math.random() - 0.5).slice(0, count);
};

export default defaultQuestions;
